import React from "react";
import {
  useReactTable,
  flexRender,
  getCoreRowModel,
} from "@tanstack/react-table";
import classes from "./table.module.css";

export const Table = ({ data, columns }) => {
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });
  return (
    <div className={classes.box}>
      <div className={classes.box__table}>
        <table className={classes.box__modelTable}>
          <thead className={classes.box__modelTable__head}>
            {table.getHeaderGroups().map((headerGroup) => (
              <tr
                key={headerGroup.id}
                className={classes.box__modelTable__head__row}
              >
                {headerGroup.headers.map((header) => (
                  <th
                    key={header.id}
                    className={classes.box__modelTable__head__row__cell}
                  >
                    {flexRender(
                      header.column.columnDef.header,
                      header.getContext()
                    )}
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody className={classes.box__modelTable__body}>
            {data.length > 0 ? (
              table.getRowModel().rows.map((row) => (
                <tr
                  key={row.id}
                  style={{ textAlign: "center", position: "relative", borderBottom: "1.5px solid #EFEFEF" }}
                >
                  {row.getVisibleCells().map((cell) => (
                    <td
                      key={cell.id}
                      className={classes.box__modelTable__body__row__data}
                    >
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      )}
                    </td>
                  ))}
                   {/* <hr className={classes.box__modelTable__body__}/> */}
                </tr>
               
              ))
            ) : (
              <tr style={{ textAlign: "center" }}>
                <td
                  colSpan={columns.length}
                  className={classes.box__modelTable__body__row__data__empty}
                >
                  No Data Available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
